import { Component, OnInit, OnDestroy, Inject } from "@angular/core";
import {
  MsalBroadcastService,
  MsalService,
  MSAL_INSTANCE,
  MsalGuardConfiguration,
  MSAL_GUARD_CONFIG,
} from "@azure/msal-angular";
import { DownloadServiceFactory } from "../core/download/download.factory";
import { Subject, fromEvent } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { DOCUMENT } from "@angular/common";
import { RolesPermissionService } from "../core/services/permissions/rolesPermission.service";
import { NgxPermissionsService } from "ngx-permissions";
import { ProductEventFactory } from "../core/product/productEvent.factory";
import {
  AuthenticationResult,
  EventMessage,
  EventType,
  IPublicClientApplication,
  RedirectRequest,
} from "@azure/msal-browser";
import { B2cConfig } from "../core/auth/b2c-config";
import { AppState } from "../core/store";
import { Store } from "@ngrx/store";
import { SettingsService } from "../core/settings/settings.service";
import { LsAuthService } from "../core/services/auth-behavior/lsauth.service";
import { VettingService } from "../core/services/vatting/vetting.service";
import { Router, ActivatedRoute } from "@angular/router";
import { OnboardingService } from "../core/services/onboarding/onboarding.service";
import { UserSettingsService } from "../core/services/usersettings/userSettingsService";
// import {
//   getWebInstrumentations,
//   SessionInstrumentation,
//   initializeFaro,
//   LogLevel,
//   faro,
// } from "@grafana/faro-web-sdk";
// import { TracingInstrumentation } from "@grafana/faro-web-tracing";
import { ProductFruitsService } from "../core/services/productfruits/product-fruits.service";
import { AppUpdateService } from "../core/services/app-update/app-update.service";

class ChangePasswordEvent extends Event {}
@Component({
  selector: "ls-root",
  template: ` <div class="container-fluid">
      <router-outlet (activate)="onActivate($event)"></router-outlet>
    </div>
    <div
      *ngIf="updateAvailable"
      class="position-fixed bottom-0 end-0 bg-white ps-4 pe-4 py-3 border border-danger-subtle rounded"
      style="z-index: 9999"
    >
      <div class="position-absolute top-0 end-0 me-1">
        <a href="javascript:void(0);" (click)="dismissUpdate()"
          ><i class="fa fa-xmark"></i
        ></a>
      </div>
      A newer version is available.
      <button class="btn btn-sm btn-outline-primary" (click)="applyUpdate()">
        Reload
      </button>
    </div>`,
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  private readonly _destroying$ = new Subject<void>();
  subscription: any;
  loggedIn: boolean = false;
  isIframe: boolean = false;
  changePasswordSubscription: any;
  vatpending: boolean = true;
  loading: boolean = false;
  updateAvailable: boolean = false;

  constructor(
    @Inject(MSAL_GUARD_CONFIG)
    private readonly msalGuardConfig: MsalGuardConfiguration,
    private readonly authService: MsalService,
    private readonly broadcastService: MsalBroadcastService,
    private readonly downloadServiceFactory: DownloadServiceFactory,
    readonly productEventFactory: ProductEventFactory,
    private readonly rolesPermissionService: RolesPermissionService,
    private readonly permissionsService: NgxPermissionsService,
    @Inject(MSAL_INSTANCE)
    private readonly msalInstance: IPublicClientApplication,
    @Inject(DOCUMENT) private readonly document: Document,
    protected settingsService: SettingsService,
    private readonly LsAuthService: LsAuthService,
    private readonly store: Store<AppState>,
    private readonly vattingService: VettingService,
    private readonly onboardingService: OnboardingService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly userSettingsService: UserSettingsService,
    private readonly productFruitsService: ProductFruitsService,
    private readonly appUpdateService: AppUpdateService,
  ) {
    downloadServiceFactory.init();
    productEventFactory.init();

    // Initialize Faro with dynamic Grafana URL from SettingsService.getSettings()
    const settings = this.settingsService.getSettings();

    const partyid = this.settingsService.getSettings().partyId;

    // Generate or retrieve persistent session ID from localStorage
    // const getOrCreateSessionId = (): string => {
    //   const storageKey = "faro_session_id";
    //   const timestampKey = "faro_session_timestamp";
    //   let sessionId = localStorage.getItem(storageKey);
    //   const timestamp = localStorage.getItem(timestampKey);

    //   // Check if session exists and is still valid (within 24 hours)
    //   const isExpired = timestamp
    //     ? Date.now() - parseInt(timestamp, 10) > 24 * 60 * 60 * 1000
    //     : true;

    //   if (!sessionId || isExpired) {
    //     // Generate a unique session ID using timestamp and random values
    //     sessionId = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
    //     localStorage.setItem(storageKey, sessionId);
    //     localStorage.setItem(timestampKey, Date.now().toString());
    //   }

    //   return sessionId;
    // };

    //const customSessionId = getOrCreateSessionId();

    // if (settings && settings.grafanaUrl) {
    //   try {
    //     const faroInstance = initializeFaro({
    //       url: settings.grafanaUrl,
    //       app: {
    //         name: "Toolkit V2",
    //         version: "1.0.0",
    //         environment: "production",
    //       },
    //       sessionTracking: {
    //         enabled: true,
    //         persistent: true,
    //         samplingRate: 0.5,
    //         generateSessionId: () => {
    //           return customSessionId;
    //         },
    //       },
    //       instrumentations: [
    //         ...getWebInstrumentations({
    //           captureConsole: true,
    //           captureConsoleDisabledLevels: [
    //             LogLevel.DEBUG,
    //             LogLevel.TRACE,
    //             LogLevel.LOG,
    //             LogLevel.INFO,
    //           ],
    //         }),
    //         new TracingInstrumentation(),
    //       ],
    //       beforeSend: (event: any) => {
    //         // Prevent submission of Google Maps tile URLs for tracing spans
    //         if (event.payload?.attributes) {
    //           const name = event.payload.attributes.name;
    //           const url = event.payload.attributes["http.url"];
    //           if (
    //             (name && name.includes("google.com/vt/lyrs=")) ||
    //             (url && url.includes("google.com/vt/lyrs="))
    //           ) {
    //             return null;
    //           }
    //         }

    //         return event;
    //       },
    //       ignoreErrors: [
    //         /Failed to fetch/i,
    //         /NetworkError/i,
    //         /Network request failed/i,
    //       ],
    //       batching: {
    //         enabled: true,
    //         sendTimeout: 5000,
    //         itemLimit: 50,
    //       },
    //     });

    //     // Inject partyId into Faro metadata if available
    //     if (partyid && faroInstance?.api) {
    //       faroInstance.api.setUser({
    //         id: partyid,
    //       });
    //     } else if (partyid) {
    //       console.warn("Faro API not available for setUser");
    //     }
    //   } catch (error) {
    //     console.error("Failed to initialize Faro:", error);
    //   }
    // } else {
    //   console.warn("Faro not initialized - missing grafanaUrl:", settings);
    // }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.downloadServiceFactory.destroy();
    this._destroying$.next();
    this._destroying$.complete();
  }

  dismissUpdate(): void {
    this.appUpdateService.dismiss();
  }

  applyUpdate(): void {
    this.appUpdateService.applyUpdate();
  }

  setLoginDisplay() {
    this.loggedIn = this.authService.instance.getAllAccounts().length > 0;
  }

  async ngOnInit(): Promise<void> {
    this.appUpdateService.updateAvailable
      .pipe(takeUntil(this._destroying$))
      .subscribe((available) => (this.updateAvailable = available));
    this.appUpdateService.init();

    this.checkoutAccount();

    const changePasswordRequest: RedirectRequest = {
      authority: B2cConfig.authority.passwordReset,
      scopes: B2cConfig.scopes,
    };

    const loginRequest: RedirectRequest = {
      authority: B2cConfig.authority.login,
      scopes: B2cConfig.scopes,
    };

    this.isIframe = window !== window.parent && !window.opener;

    this.broadcastService.msalSubject$.subscribe((event: EventMessage) => {
      if (
        event.eventType == EventType.LOGIN_FAILURE ||
        event.eventType == EventType.ACQUIRE_TOKEN_FAILURE ||
        event.eventType == EventType.SSO_SILENT_FAILURE
      ) {
        const errorMessage = event.error?.message ?? "";
        if (errorMessage.indexOf("AADB2C90118") !== -1) {
          this.authService.loginRedirect(changePasswordRequest);
        }
        if (errorMessage.indexOf("AADB2C90091") !== -1) {
          this.authService.loginRedirect(loginRequest);
        }

        localStorage.setItem("ErrorDescription", errorMessage);
        this.router.navigate(["error"]);
      }
    });

    this.changePasswordSubscription = fromEvent<ChangePasswordEvent>(
      this.document,
      "changePassword",
    ).subscribe((e) => {
      this.authService.loginRedirect(changePasswordRequest);
    });

    this.authService.handleRedirectObservable().subscribe({
      next: (result: AuthenticationResult) => {
        if (result) {
          localStorage.setItem("msal.idtoken", result.idToken);
          this.authService.instance.setActiveAccount(result.account);
          this.checkoutAccount();
        }
      },
      error: (error) => {
        console.log(error);
      },
    });

    if (this.loggedIn) {
      const expirydate = this.settingsService.getTokenExpiryDate();
      if (expirydate < new Date()) {
        this.logout();
        return;
      }

      const permissions: string[] = [];
      this.rolesPermissionService.getRolesAndPermissions().subscribe((x) => {
        if (x) {
          x.forEach((role) => {
            role.permissions.forEach((element) => {
              permissions.push(element.name.toUpperCase());
            });
          });
          this.permissionsService.addPermission(permissions);
        }
      });
    }
  }

  checkoutAccount() {
    const acc = this.msalInstance.getActiveAccount();
    if (acc) {
      const expirydate = this.settingsService.getTokenExpiryDate();
      if (expirydate < new Date()) {
        this.logout();
        return;
      }
      this.setLoggedInAccount();
    }
  }

  async setLoggedInAccount() {
    this.msalInstance.setActiveAccount(this.msalInstance.getAllAccounts()[0]);
    let acc: any = this.msalInstance.getActiveAccount();
    await this.userSettingsService.loadSettings();
    if (acc) {
      localStorage.setItem("msal.idtoken", acc.idToken);
    }

    if (acc.idTokenClaims["email"]) {
      localStorage.setItem(
        "signedinEmail",
        acc.idTokenClaims["email"].toString(),
      );
    }

    // Initialize Product Fruits with current user information
    try {
      const email =
        acc.idTokenClaims["email"] ||
        acc.idTokenClaims["emails"]?.[0] ||
        "unknown";
      const username =
        acc.idTokenClaims["given_name"] || email.split("@")[0] || email;

      this.productFruitsService.initialize(username, {
        email: email,
        givenName: acc.idTokenClaims["given_name"] || "",
        familyName: acc.idTokenClaims["family_name"] || "",
        oid: acc.idTokenClaims["oid"] || "",
      });
    } catch (error) {
      console.error("Error initializing Product Fruits:", error);
    }

    const initialRoute = localStorage.getItem("InitialLoadUrl");
    if (
      initialRoute &&
      initialRoute.indexOf("onsell") === -1 &&
      initialRoute.indexOf("product") === -1
    ) {
      localStorage.removeItem("InitialLoadUrl");
      this.router.navigateByUrl(initialRoute);
    } else {
      localStorage.removeItem("InitialLoadUrl");
    }
  }

  refresh() {
    this.vattingService.refreshVattingState.next(true);
  }

  logout() {
    // Clean up Product Fruits
    this.productFruitsService.destroy();

    this.msalInstance
      .initialize()
      .then(() => {
        this.authService.instance.logout({
          postLogoutRedirectUri: window.location.href,
        });
      })
      .catch((error) => {
        console.error("Error initializing MSAL", error);
        let currentUrl =
          this.document.location.href.split("#")[0] + "#/?logout=true";
        this.document.location.href = currentUrl;
      });
  }

  onActivate(event: any) {
    window.scroll(0, 0);
  }
}
